import HostLocations  from './HostLocations';

export default HostLocations;
